module.exports = __webpack_public_path__ + "img/be_selected.093e0fea.png";